// Types
import { FETCH_SUBMISSION } from "constants/types";

// Helpers
import { apiRequest } from "helpers/apiClient";

export const fetchSubmission = (guid) => (dispatch) => {
    return apiRequest(`/api/v1/Innsending/${guid}`, {
        headers: { Accept: "application/hal+json" }
    }).then((result) => {
        if (result.ok) {
            const form = result.data;
            dispatch({ type: FETCH_SUBMISSION, payload: form });
            return form;
        }
        // Feil: marker tydelig (fetchError) med HTTP-status, så kallere kan skille 404 (finnes ikke)
        // fra 500/nettverksfeil (teknisk feil). `fetchError` skiller dette fra en ekte innsending
        // (som har et `status`-felt = skjemastatus-streng, ikke en HTTP-kode).
        return {
            fetchError: true,
            status: result.status,
            xCorrelationId: result.xCorrelationId
        };
    });
};
